import React from 'react';
import { Link } from 'react-router-dom';
import './disabledLink.scss'; // Import the CSS file for styling

const DisabledLink = ({ to, onClick, children, disabled, className }: any) => {
  if (disabled) {
    return <span className={`${className} disabled-link`}>{children}</span>;
  }
  return <Link to={to} onClick={onClick} className={className}>{children}</Link>;
};

export default DisabledLink;